(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PendenciasCtrl', PendenciasController);

  PendenciasController.$inject = [
    'LoadingService',
    'MessagesService',
    '$rootScope',
    'PendenciasService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function PendenciasController(LoadingService, MessagesService, $rootScope, PendenciasService) {
    const vm = this;

    // Controller data
    vm.loading = true;
    vm.pendencias = [];

    vm.safra = null;
    vm.gleba = null;

    vm.loadPendencias = loadPendencias;

    // Function declarations
    function loadPendencias() {
      vm.loading = true;
      vm.pendencias = [];

      return PendenciasService.pendenciasPorGleba({
        safra: vm.safra.id,
        propriedade: $rootScope.currentPropriedade.id,
        gleba: _.get(vm.gleba, 'id')
      })
        .then((data) => {
          vm.pendencias = data;
        })
        .catch((error) => {
          MessagesService.alert('Erro ao carregar tarefas pendentes. Tente novamente mais tarde!');
          console.error(error);
          vm.pendencias = [];
        })
        .finally(() => {
          vm.loading = false;
        });
    }

    // Controller logic
    LoadingService.showLoading();
    $rootScope.initialize
      .then(() => {
        if (!$rootScope.permissions.tarefa.canRead) {
          MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
          return;
        }

        $rootScope.bodyClass = 'gray-bg';
        vm.safra = _.find($rootScope.safras, 'current');
        return loadPendencias();
      })
      .catch(() => {
        $rootScope.errorRootInitialize();
      })
      .finally(LoadingService.hideLoading);
  }
}());
